'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('document-upload', {
      url: '/document/upload',
      template: '<document-upload></document-upload>',
        authenticate: 'admin'
    }).state('document-upload-type', {
      url: '/document/upload/:type',
      template: '<document-upload></document-upload>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/document/upload/document-upload.routes.js